<template>
  <img
    :alt="fullName"
    :aria-label="`${fullName} avatar`"
    :class="{
      'tw-h-10 tw-w-10': size === 'base',
      'tw-h-8 tw-w-8': size === 'sm',
      'tw-h-12 tw-w-12': size === 'lg',
      'tw-h-4 tw-w-4': size === 'xxs',
    }"
    :title="fullName"
    :data-blink-src="avatarUrl"
    class="
      tw-border tw-border-white tw-rounded-full tw-object-contain tw-text-xxs
    "
  />
</template>

<script>
import { getMemberFullName } from '@/utils/members'
import nestedJSONParse from '@/utils/nestedJSONParse'

export default {
  name: 'MemberAvatar',
  props: {
    member: {
      type: Object,
      required: true,
    },
    size: {
      default: 'base',
      required: false,
      type: String,
      validator: (value) => {
        return ['base', 'sm', 'lg', 'xxs'].includes(value)
      },
    },
  },
  computed: {
    entityUuid() {
      return this.member.entityUuid ? this.member.entityUuid : this.member.id
    },
    parsedMemberMeta() {
      // make sure that meta is an Object
      if (typeof this.member.meta === 'string') {
        return nestedJSONParse(this.member.meta)
      }
      return this.member.meta
    },
    avatarUrl() {
      const _avatarUrl =
        this.parsedMemberMeta?.avatar_url ?? this.parsedMemberMeta?.avatarUrl
      return _avatarUrl || '/images/default_user_avatar.jpeg'
    },
    fullName() {
      return getMemberFullName(this.member)
    },
  },
}
</script>
